'use strict';

var _ = require('lodash');
var GridColumnFactory = function GridColumnFactory(distanceUnitService, momentService, userSecureService) {
  function getGridId(data) {
    return _.first(data.gridId.split(':'));
  }
  var GridColumn = function GridColumn(data) {
    if (!_.isString(data.gridId) || !_.isString(data.field)) {
      throw new Error('should provide gridId and field parameters');
    }
    this.id = getGridId(data) + '-' + data.field;
    this.field = data.field;
    this.title = data.applyDistanceUnit === true ? distanceUnitService.applySuffix(data.title) : data.title;
    this.originalTitle = data.originalTitle || undefined;
    this.groupId = data.groupId || undefined;
    this.groupTitle = data.groupTitle || undefined;
    this.frozen = data.frozen || false;
    this.visible = data.visible || false;
    this.custom = data.custom || false;
    this.formula = data.formula;
    this.width = data.width;
    this.format = data.format;
    this.renderer = data.renderer;
    this.tooltip = data.tooltip;
    this.fieldAlias = data.fieldAlias;
    this.editable = data.editable;
    this.columntype = data.columntype;
    this.validations = data.validations || [];
    this.applyDistanceUnit = data.applyDistanceUnit;
    this.momentConfig = getMomentConfig(data.momentConfig);
    this.cellsalign = data.cellsalign || undefined;
    this.differentTypesColumn = data.differentTypesColumn;
    this.serverSortingAvailable = _.isUndefined(data.serverSortingAvailable) ? true : data.serverSortingAvailable;
    this.filterable = data.filterable;
    this.sortable = data.sortable;
    this.menu = data.menu;
    this.fillDownDisabled = data.fillDownDisabled;
    this.columnMetadata = data.columnMetadata;
    this.maxAllowedYear = data.maxAllowedYear;
    this.prependEmptyValue = data.prependEmptyValue;
    this.allowEmptyValue = !!data.allowEmptyValue;
    this.isUserColumn = !!data.isUserColumn;
    this.dynamicGroupName = data.dynamicGroupName;
    this.afterColumnPosition = data.afterColumnPosition;
    this.showOnlyTime = data.showOnlyTime;
    this.delayOneClickSelection = data.delayOneClickSelection;
    this.headerIcon = data.headerIcon;
    this.headerIconTooltip = data.headerIconTooltip;
    this.fieldVariant = data.fieldVariant;
    if (data.cellsformat) {
      this.cellsformat = data.cellsformat;
    }
    if (data.permissions && !_.isUndefined(data.editable)) {
      var isAuthorized = userSecureService.hasAuthorization(data.permissions.component, data.permissions.permission);
      this.authorized = isAuthorized;
      this.editable = this.authorized ? this.editable : false;
    }
    if (data.editableIf) {
      this.editableIf = data.editableIf;
    }
    convertRightOperandToFloat(data);
  };
  function convertRightOperandToFloat(data) {
    if (data.formula && data.formula.rightOperand) {
      var test = parseFloat(data.formula.rightOperand);
      if (_.isNaN(test) === false) {
        data.formula.rightOperand = test;
      }
    }
  }
  function getMomentConfig(momentConfig) {
    if (_.isString(momentConfig)) {
      return momentService.getConfig(momentConfig);
    } else {
      return momentConfig;
    }
  }
  GridColumn.prototype.updateParent = function (parent) {
    this.groupId = parent.id;
    this.groupTitle = parent.title;
    this.originalTitle = this.title;
  };
  GridColumn.prototype.toExportFormat = function () {
    var data = this;
    return {
      field: data.field,
      title: data.title,
      frozen: data.frozen,
      visible: data.visible,
      custom: data.custom,
      formula: data.formula,
      width: data.width,
      applyDistanceUnit: data.applyDistanceUnit
    };
  };
  GridColumn.prototype.toMergeFormat = function () {
    return {
      field: this.field,
      title: this.title,
      frozen: this.frozen,
      visible: this.visible,
      custom: this.custom,
      formula: this.formula,
      width: this.width,
      format: this.format,
      renderer: this.renderer,
      tooltip: this.tooltip,
      fieldAlias: this.fieldAlias,
      editable: this.editable,
      columntype: this.columntype,
      cellsformat: this.cellsformat,
      validations: this.validations,
      applyDistanceUnit: this.applyDistanceUnit,
      UTC: this.UTC,
      momentConfig: this.momentConfig,
      authorized: this.authorized,
      editableIf: this.editableIf,
      menu: this.menu,
      filterable: this.filterable,
      sortable: this.sortable,
      isUserColumn: this.isUserColumn,
      delayOneClickSelection: this.delayOneClickSelection,
      headerIcon: this.headerIcon,
      headerIconTooltip: this.headerIconTooltip,
      fillDownDisabled: this.fillDownDisabled,
      columnMetadata: this.columnMetadata
    };
  };
  return GridColumn;
};
GridColumnFactory.$inject = ['DistanceUnitService', 'MomentService', 'UserSecureService'];
module.exports = GridColumnFactory;